/**
 * JWT token utilities for extracting permissions
 */

export type Permission = 
  | 'all.read'           // Can view all operational records (orders, chats, walk-ins, appointments)
  | 'payments.read'      // Can view payments/ledger/reconciliation
  | 'payments.manage';   // Can create/edit payments

interface JWTPayload {
  id: string;
  username: string;
  role: string;
  permissions?: Permission[];
  session_id?: string;
  iat?: number;
  exp?: number;
}

/**
 * Decodes JWT token and extracts permissions
 * 
 * @param token - JWT token string
 * @returns Array of permissions or empty array if token is invalid
 */
export function extractPermissionsFromToken(token: string | null): Permission[] {
  if (!token) {
    return [];
  }

  try {
    // JWT tokens have 3 parts separated by dots: header.payload.signature
    const parts = token.split('.');
    if (parts.length !== 3) {
      return [];
    }

    // Decode the payload (second part)
    const payload = parts[1];
    // Base64URL decode
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    const parsed: JWTPayload = JSON.parse(decoded);

    // Return permissions from token, or empty array if not present
    return parsed.permissions || [];
  } catch (error) {
    console.error('Error extracting permissions from token:', error);
    return [];
  }
}


